import { render, staticRenderFns } from "./login-motto.vue?vue&type=template&id=2dc91e9e&scoped=true"
var script = {}
import style0 from "./login-motto.vue?vue&type=style&index=0&id=2dc91e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc91e9e",
  null
  
)

export default component.exports